import { Route, Switch, useRouteMatch } from "react-router-dom";
import React from "react";
import AnalystQueueContainer from "../Container/Analyst/AnalystQueueContainer";
import AnalystStepperContainer from "../Container/Analyst/AnalystStepperContainer";

const AnalystRouter = () => {
  let match = useRouteMatch();
  return (
    <Switch>
      <Route
        path={`${match.url}/analyst-workflow/:id`}
        render={(props) => {
          // eslint-disable-next-line react/prop-types
          return <AnalystStepperContainer id={props.match.params.id} />;
        }}
      />
      <Route path={`${match.url}`}>
        <AnalystQueueContainer />
      </Route>
    </Switch>
  );
};

export default AnalystRouter;
